import toast from "../../../template/layout/utility/sa-toast";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	mixins: [UtilityMixin],
	data() {
		return {
			search: "",
			openPrestazioni: [], // Array per gestire l'espansione delle singole prestazioni
			mappaColori: {
				"IP (Infermiere)": "#3498db",
				"FISIO (Fisioterapista)": "#2ecc71",
				OSS: "#e67e22",
				"PSIC (Psicologo)": "#9b59b6",
				"MED (Medico)": "#e74c3c",
			},
			pratiche: [],
			rows:0,
			siatConfermaPianificazionePathResource: "/siat/scritturainterventi",
			siatLetturaPianiSceltaPathResource: "/siat/letturapianiscelta",
			siatLetturaPianiAssegnatiPathResource: "/siat/letturapiani",
			siatConfermaLetturaPathResource: "/siat/confermalettura",
			siatConfermaLetturaAggiornamentoPathResource: "/siat/confermaletturaaggiornamento",
			siatConfermaLetturaSceltaPathResource: "/siat/confermaletturapianiscelta",
			siatAccettaRifiutaPathResource: "/siat/accettarifiutapai",
			eventoSelezionato: null,

			praticheSiatPathResource: "/siatpratiche",
			praticheSiatItems: [],
			praticheSiatRowsNumber: 0
		};
	},
	methods: {
		praticheSiatLoadData(filtro) {
			this.openShowModalLoading();
			UtilityMixin.methods.loadDataResources(this.praticheSiatPathResource, filtro, this.praticheSiatLoadDataSuccess, this.praticheSiatLoadDataError);
		},
		praticheSiatLoadDataSuccess(response) {
			this.praticheSiatItems = response.data.data.list ? response.data.data.list : [];
			this.praticheSiatRowsNumber = response.data.data.recordsNumber;
			this.closeShowModalLoading();
			toast.success("Caricamento Pratiche Avvenuto con Successo");
		},
		praticheSiatLoadDataError() {
			this.closeShowModalLoading();
			toast.error("Errore durante caricamento pratiche siat");
		},
		siatLoadLetturaPianiScelta() {
			this.openShowModalLoading();
			UtilityMixin.methods.loadDataResources(this.siatLetturaPianiSceltaPathResource, {}, this.siatLoadLetturaPianiSceltaSuccess, this.siatLoadLetturaPianiSceltaError);
		},
		siatLoadLetturaPianiSceltaSuccess(response) {
			console.log(response.data.data);
			this.pratiche = response.data.data ? response.data.data : [];
			console.log(this.pratiche);
			this.closeShowModalLoading();
		},
		siatLoadLetturaPianiSceltaError() {
			toast.error("Errore durante caricamento lettura piani");
			this.closeShowModalLoading();
		},

		siatConfermaPianificazione(id, callback = null) {
			this.openShowModalLoading();
			let link = process.env.VUE_APP_PATH_API + this.siatLetturaPianiSceltaPathResource + "/" + id;
			UtilityMixin.methods.restCallPut(link, {}, callback, this.siatConfermaPianificazioneError);
		},
		siatConfermaPianificazioneError() {
			toast.error("Errore durante conferma pianificazione");
			this.closeShowModalLoading();
		},

		siatConfermaLetturaScelta(evento) {
			this.eventoSelezionato = evento;
			this.openShowModalLoading();
			UtilityMixin.methods.putResource(this.siatConfermaLetturaSceltaPathResource + "/" + evento.id, {}, this.siatConfermaLetturaSceltaSuccess, this.siatConfermaLetturaSceltaError);
		},
		siatConfermaLetturaSceltaSuccess(response) {
			console.log(response);
			this.closeShowModalLoading();
		},
		siatConfermaLetturaSceltaError(error) {
			let message = error?.response.data?.messaggio;
			this.$set(this.eventoSelezionato, "errorePresa", message);
			this.eventoSelezionato = null;
			this.closeShowModalLoading();
		},
		siatConfermaLettura(evento) {
			this.eventoSelezionato = evento;
			this.openShowModalLoading();
			UtilityMixin.methods.putResource(this.siatConfermaLetturaPathResource + "/" + evento.id, {}, this.siatConfermaLetturaSuccess, this.siatConfermaLetturaError);
		},
		siatConfermaLetturaSuccess(response) {
			console.log(response);
			this.closeShowModalLoading();
		},
		siatConfermaLetturaError(error) {
			let message = error?.response.data?.messaggio;
			this.$set(this.eventoSelezionato, "errorePresa", message);
			this.eventoSelezionato = null;
			this.closeShowModalLoading();
		},
		siatConfermaLetturaAggiornamento(evento) {
			this.eventoSelezionato = evento;
			this.openShowModalLoading();
			UtilityMixin.methods.putResource(this.siatConfermaLetturaAggiornamentoPathResource + "/" + evento.id, {}, this.siatConfermaLetturaAggiornamentoSuccess, this.siatConfermaLetturaAggiornamentoError);
		},
		siatConfermaLetturaAggiornamentoSuccess(response) {
			response;
			this.closeShowModalLoading();
		},
		siatConfermaLetturaAggiornamentoError(error) {
			let message = error?.response.data?.messaggio;
			this.$set(this.eventoSelezionato, "errorePresa", message);
			this.eventoSelezionato = null;
			this.closeShowModalLoading();
		},
		siatLoadLetturaPianiAssegnati(filtro) {
			this.openShowModalLoading();
			UtilityMixin.methods.loadDataResources(this.siatLetturaPianiAssegnatiPathResource, filtro, this.siatLoadLetturaPianiAssegnatiSuccess, this.siatLoadLetturaPianiAssegnatiError);
		},
		siatLoadLetturaPianiAssegnatiSuccess(response) {
			this.pratiche = response.data.data.list ? response.data.data.list : [];
			this.rows =response.data.data.recordsNumber;
			this.closeShowModalLoading();
		},
		siatLoadLetturaPianiAssegnatiError() {
			console.error("Errore nel caricamento dei dati per storico stati setting");
			this.closeShowModalLoading();
		},
		onClickAccettaRifiutaPai(value, evento, codicePacchetto, stato) {
			this.eventoSelezionato = evento;
			this.openShowModalLoading();
			let link = process.env.VUE_APP_PATH_API + this.siatAccettaRifiutaPathResource;
			let body = { stato: stato, paId: value.po_id, codicePacchetto: codicePacchetto };
			UtilityMixin.methods.restCallPost(link, body, this.clickAccettaRifiutaPaiSuccess, this.lickAccettaRifiutaPaiError);
		},

		clickAccettaRifiutaPaiSuccess(response) {
			response;
			this.closeShowModalLoading();
		},
		lickAccettaRifiutaPaiError(error) {
			let message = error?.response.data?.messaggio;
			this.$set(this.eventoSelezionato, "errorePresa", message);
			this.eventoSelezionato = null;
			this.closeShowModalLoading();
		},
		onClickConfermaPainificazione(evento, intervento = null) {
			this.eventoSelezionato = evento;
			this.openShowModalLoading();
			if (intervento === null) {
				UtilityMixin.methods.putResource(this.siatConfermaPianificazionePathResource + "/" + evento.id, {}, this.siatConfermaPianificazioneSuccess, this.siatConfermaPianificazioneListError);
			} else {
				UtilityMixin.methods.putResource(this.siatConfermaPianificazionePathResource + "/" + evento.id, intervento, this.siatConfermaPianificazioneSuccess, this.siatConfermaPianificazioneListError);
			}
		},
		siatConfermaPianificazioneSuccess(response) {
			console.log(response);
			this.closeShowModalLoading();
		},
		siatConfermaPianificazioneListError(error) {
			let message = error?.response.data?.messaggio;
			this.$set(this.eventoSelezionato, "errorePresa", message);
			this.eventoSelezionato = null;
			this.closeShowModalLoading();
		},
	},
};
